module.exports = __webpack_public_path__ + "f7f28091ce690a4b2678aa70b490d7f1.pdf";